import { createFileRoute } from '@tanstack/react-router';

import { ManagedAccountsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();
  return (
    <ManagedAccountsTab
      advisoryOrganizationId={params.advisoryOrganizationId}
    />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/managed-accounts'
)({
  component: Page
});
